function setNewEmail(elems, email) {
    elems.each(function (idx, itm) {
        $(itm).text(email);
        $(itm).attr("href", `mailto:${email}`);
    });
}

App.W.on("barba:afterEnter", () => {
    let wrap_elements = $('[gtm_element_id="header_email_link"]');

    window.dataLayer = window.dataLayer || [];

    setTimeout(() => {
        if (sessionStorage.getItem("utm") === "tagline") {
            setNewEmail(wrap_elements, "sale@cpeople.team");

            window.dataLayer.push({
                event: "utm_detected",
            });
        }

        if (sessionStorage.getItem("utm") === "telegram") {
            setNewEmail(wrap_elements, "communication@cpeople.team");

            window.dataLayer.push({
                event: "utm_detected",
            });
        }
    }, 250);
});



// WEBPACK FOOTER //
// ./_src/js/modules/SetEmailWithUTM.js